export const Roles = Object.freeze({
    TEACHER: 'teacher',
    STUDENT: 'student',
    ADMIN: 'admin',
});
